/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

module.exports = reEscape;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_reEscape.js
// module id = 1245
// module chunks = 0